/**
 * Standard size for the lone anvil centred in a pane or page while it loads
 * (SessionLoadingScreen, CanvasLoader). 80px is the sprites' native size, so
 * their 1-pixel details stay crisp at 1x and 2x DPR; the inline chat working
 * indicator stays at 40px.
 */
export const CENTERED_LOADING_ANVIL_SIZE_PX = 80;

/** Tailwind twin of CENTERED_LOADING_ANVIL_SIZE_PX (size-20 = 80px). */
export const CENTERED_LOADING_ANVIL_SIZE_CLASS = "size-20";
